"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TablePagination = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TableFooter = _interopRequireDefault(require("@material-ui/core/TableFooter"));

var _TablePagination = _interopRequireDefault(require("@material-ui/core/TablePagination"));

var _TableRow = _interopRequireDefault(require("../TableRow"));

var _TablePaginationActions = _interopRequireDefault(require("./TablePaginationActions.js"));

var _styles = require("@material-ui/core/styles");

var _styles2 = require("./styles");

var _classnames = _interopRequireDefault(require("classnames"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var TablePagination = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TablePagination, _Component);

  var _super = _createSuper(TablePagination);

  function TablePagination() {
    var _this;

    (0, _classCallCheck2.default)(this, TablePagination);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _this$props = _this.props,
          id = _this$props.id,
          count = _this$props.count,
          labelRowsPerPage = _this$props.labelRowsPerPage,
          onChangePage = _this$props.onChangePage,
          onChangeRowsPerPage = _this$props.onChangeRowsPerPage,
          page = _this$props.page,
          rowsPerPage = _this$props.rowsPerPage,
          rowsPerPageOptions = _this$props.rowsPerPageOptions,
          className = _this$props.className,
          component = _this$props.component,
          classes = _this$props.classes;

      var pagination = /*#__PURE__*/_react.default.createElement(_TablePagination.default, {
        id: id,
        className: (0, _classnames.default)("prmbl-tablePagination", className, classes.pagination),
        classes: {
          select: classes.paginationSelect + " prmbl-tablePagination-select",
          menuItem: "prmbl-tablePagination-menuItem",
          input: "prmbl-tablePagination-input",
          toolbar: (0, _classnames.default)("prmbl-tablePagination-toolbar", classes.toolbar)
        },
        page: page,
        labelRowsPerPage: labelRowsPerPage,
        rowsPerPage: rowsPerPage,
        count: count,
        onChangePage: onChangePage,
        backIconButtonProps: {
          "aria-label": "Previous Page"
        },
        nextIconButtonProps: {
          "aria-label": "Next Page"
        },
        onChangeRowsPerPage: onChangeRowsPerPage,
        rowsPerPageOptions: rowsPerPageOptions,
        component: component,
        ActionsComponent: function ActionsComponent() {
          return /*#__PURE__*/_react.default.createElement(_TablePaginationActions.default, {
            id: id,
            count: count,
            onChangePage: onChangePage,
            page: page,
            rowsPerPage: rowsPerPage
          });
        },
        labelDisplayedRows: function labelDisplayedRows(_ref) {
          var from = _ref.from,
              to = _ref.to,
              count = _ref.count;
          return "";
        }
      });

      return component ? pagination : /*#__PURE__*/_react.default.createElement(_TableFooter.default, null, /*#__PURE__*/_react.default.createElement(_TableRow.default, {
        className: "prmbl-tablePagination-row",
        id: "".concat(id, "-pagination-row")
      }, pagination));
    });
    return _this;
  }

  return TablePagination;
}(_react.Component);

exports.TablePagination = TablePagination;
(0, _defineProperty2.default)(TablePagination, "propTypes", {
  /**
   * The html id
   */
  id: _propTypes.default.string.isRequired,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.string,

  /**
   * The total number of rows
   */
  count: _propTypes.default.number.isRequired,

  /**
   * The label to associate with the per page option selection
   */
  labelRowsPerPage: _propTypes.default.string,

  /**
   * Callback fired when the page is changed.
   *
   * Signature: `function(event: object, page: number) => void`
   * event: The event source of the callback
   * page: The page selected
   */
  onChangePage: _propTypes.default.func.isRequired,

  /**
   * Callback fired when the number of rows per page is changed.
   *
   * Signature: `function(event: object) => void`
   * event: The event source of the callback.
   */
  onChangeRowsPerPage: _propTypes.default.func,

  /**
   * The zero-based index of the current page.
   */
  page: _propTypes.default.number.isRequired,

  /**
   * The number of rows per page.
   */
  rowsPerPage: _propTypes.default.number.isRequired,

  /**
   * The options for rows per page.
   */
  rowsPerPageOptions: _propTypes.default.arrayOf(_propTypes.default.number),

  /**
   * @ignore
   *
   * Utilized By:
   * CivicEngage, CP Platform
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   *
   * Utilizing this to style up the page don't want to expose this in the style guide.
   * Auto-populated by material-ui withStyles()
   */
  classes: _propTypes.default.object.isRequired
});
(0, _defineProperty2.default)(TablePagination, "defaultProps", {
  page: 0,
  rowsPerPage: 10,
  rowsPerPageOptions: [10, 25, 50, 100],
  className: ""
});

var _default = (0, _styles.withStyles)(_styles2.styles)(TablePagination);

exports.default = _default;